import { inject } from "@angular/core";
import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { HttpRequest, HttpHandlerFn, HttpEvent } from "@angular/common/http";
import { StorageKeys } from "@core-interfaces/global";
import { Observable, throwError } from "rxjs";
import { AuthManager } from "@infra-adapters/services/auth.service";
import { SessionExpiryRedirectService } from "@infra-adapters/services/session-expiry-redirect.service";

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const auth = inject(AuthManager);
  const sessionExpiry = inject(SessionExpiryRedirectService);

  // No enviar Bearer en login: un token viejo puede hacer fallar el POST o provocar 401 en bucle.
  const isAuthLogin =
    req.url.includes("/authorization/login") ||
    req.url.includes("authorization/login");
  if (isAuthLogin) {
    return next(req);
  }

  const token = sessionStorage.getItem(StorageKeys.session_token);
  if (!token) {
    return next(req);
  }

  if (!auth.isAuth()) {
    sessionExpiry.redirectBecauseExpired();
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 401,
          statusText: "Unauthorized",
          url: req.url,
          error: { message: "Sesión expirada" },
        }),
    );
  }

  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
  return next(clonedRequest);
};
